/**
 *
 *  Based on the script linked below, modified by us to turn it into an importable JS module.
 *
 *
 *  disqusLoader.js v1.0
 *  A JavaScript plugin for lazy-loading Disqus comments widget.
 *  https://github.com/osvaldasvalutis/disqusLoader.js
 *	-
 *	By Osvaldas Valutis, www.osvaldas.info
 *  Available for use under the MIT License
 */

"use strict";

var config = {
	laziness: 0,
	throttle: 500,
	scriptUrl: 'https://simpletalk.disqus.com/embed.js',
	disqusConfig: function() {
		this.page = {
			identifier: window.location.pathname,
			url: window.location.href
		}
	}
};

var getOffset = function(el) {
	var rect = el.getBoundingClientRect();
	return { top: rect.top + document.body.scrollTop, left: rect.left + document.body.scrollLeft };
};
	
var loadScript = function(url, callback) {
	var script = document.createElement("script");
	script.src = url;
	script.async = true;
	script.setAttribute("data-timestamp", +new Date());
	script.addEventListener("load", function() {
		if (typeof callback === "function") callback();
	});
	(document.head || document.body).appendChild(script);
};

var throttle = function(a, b) {
	var c, d;
	return function() {
		var e = this,
			f = arguments,
			g = +new Date();
		c && g < c + a
			? (clearTimeout(d),
				(d = setTimeout(function() {
					(c = g), b.apply(e, f);
				}, a)))
			: ((c = g), b.apply(e, f));
	};
};

var throttleTO = false;
var laziness = false;
var disqusConfig = false;
var scriptUrl = false;
var scriptStatus = "unloaded";
var instance = false;


/**
 * Renamed from init
 * 
 * @param {bool} force A new param added by us, so we can use this function as the handler for the Load comments button. 
 * 					   Set to 'true' to ignore the check on viewport position. 
 */
var main = function( force ) {
	if (!instance || !document.body.contains(instance) || instance.disqusLoaderStatus == "loaded") return true;
	
	if ( force !== true ) {
		// if the element is too far below || too far above
		var winST = window.pageYOffset;
		var offset = getOffset(instance).top;

		if (offset - winST > window.innerHeight * laziness || winST - offset - instance.offsetHeight - window.innerHeight * laziness > 0) return true;
	}

	var tmp = document.getElementById("disqus_thread");
	if (tmp) tmp.removeAttribute("id");
	instance.setAttribute("id", "disqus_thread");
	instance.disqusLoaderStatus = "loaded";

	if (typeof DISQUS !== 'undefined' && DISQUS.reset) {
		DISQUS.reset({ reload: true, config: disqusConfig });
	} else {
		window.disqus_config = disqusConfig;
		if (scriptStatus == "unloaded") {
			scriptStatus = "loading";
			loadScript(scriptUrl, function() {
				scriptStatus = "loaded";
			});
		}
	}
};

// New init function added so we can export it
var init = function() {
    window.addEventListener("scroll", throttle(throttleTO, main));
    window.addEventListener("resize", throttle(throttleTO, main));
    
    // Listen for theme changes - with better checks

	document.addEventListener('colorModeChanged', function() {
		if (typeof DISQUS !== 'undefined' && DISQUS.reset) {
            DISQUS.reset({
                reload: true,
                config: config.disqusConfig
            });
        }
    });
    
    // Add event listener to Load comments button
    var button = document.querySelector('a[href="#load-disqus"]');
    if (button) {
        button.addEventListener("click", function(e) {
            e.preventDefault();
            main(true);
        });
    }

    window.disqusLoader = function(element, options) {

        laziness = options.laziness + 1;
        throttleTO = options.throttle;
        disqusConfig = options.disqusConfig;
        scriptUrl = scriptUrl === false ? options.scriptUrl : scriptUrl; // set it only once

        if (typeof element === "string") instance = document.querySelector(element);
        else if (typeof element.length === "number") instance = element[0];
        else instance = element;

        if (instance) instance.disqusLoaderStatus = "unloaded";

        main();
		
    };

    window.disqusLoader('.js-disqus', config);
};

export default { init };
